var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};

// src/index.ts
__export(exports, {
  default: () => TagInput
});

// src/TagInput.tsx
var import_react = __toModule(require("react"));
var import_color_hash = __toModule(require("color-hash"));
var colorHash = new import_color_hash.default();
var defaultCompleteKeys = ["Enter", "Tab", ","];
var TagInput = (props) => {
  const {
    value = [],
    onChange,
    options = [],
    colorize,
    placeholder,
    completeKeys = defaultCompleteKeys
  } = props;
  const inputRef = (0, import_react.useRef)(null);
  const onKeyDown = (event) => {
    const { key } = event;
    if (completeKeys.includes(key)) {
      let { value: newTagValue } = inputRef.current;
      newTagValue = newTagValue.trim();
      event.preventDefault();
      if (!newTagValue.length) {
        return;
      }
      if (value.includes(newTagValue)) {
        return;
      }
      inputRef.current.value = "";
      onChange([...value, newTagValue]);
    }
    if (key === "Backspace") {
      const { value: newTagValue } = inputRef.current;
      if (!newTagValue.trim().length) {
        onChange(value.slice(0, value.length - 1));
      }
    }
  };
  function removeTag(removedTag) {
    onChange(value.filter((tag) => tag !== removedTag));
  }
  function focusOnInput() {
    inputRef.current.focus();
  }
  return /* @__PURE__ */ import_react.default.createElement("div", {
    className: "tag-input",
    onClick: focusOnInput
  }, value == null ? void 0 : value.map((tag) => /* @__PURE__ */ import_react.default.createElement("span", {
    className: "tag",
    "data-testid": "tag",
    key: tag,
    style: colorize ? { backgroundColor: colorHash.hex(tag) } : {}
  }, tag, /* @__PURE__ */ import_react.default.createElement("button", {
    "data-testid": "remove-tag-button",
    className: "remove-tag-button",
    onClick: () => removeTag(tag)
  }, "\xD7"))), /* @__PURE__ */ import_react.default.createElement("input", {
    "data-testid": "new-tag-input",
    className: "new-tag",
    type: "text",
    onKeyDown,
    ref: inputRef,
    list: "tags",
    placeholder
  }), /* @__PURE__ */ import_react.default.createElement("datalist", {
    id: "tags"
  }, options.map((option) => /* @__PURE__ */ import_react.default.createElement("option", {
    key: option,
    value: option,
    "data-testid": "option"
  }, option))));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
//# sourceMappingURL=index.js.map
